import React from 'react'
import './TagDefaultFeirao.scss'

const TagDefaultFeirao = () => (
    <strong
        id="TagVehicleFeirao"
        className='TagDefaultFeirao'
    >
        Oferta destaque
    </strong>
)

export default TagDefaultFeirao
